import { type Parser, parseAsString, useQueryStates } from "nuqs";
import { filterTypes as ALL_FILTER_TYPES } from "../types/filter";

/** Every filter type set to `null` — what `setState` needs to clear the
 *  whole filter bar in one URL update (nuqs drops a null key). */
export function clearedFilterState(): Record<string, null> {
  const cleared: Record<string, null> = {};
  for (const filterType of Object.values(ALL_FILTER_TYPES)) {
    cleared[filterType] = null;
  }
  return cleared;
}

export function useFilterSearchState() {
  const filterStates = {} as { [x: string]: Parser<string> };

  for (const filterType of Object.values(ALL_FILTER_TYPES)) {
    filterStates[filterType] = parseAsString;
  }

  return useQueryStates(filterStates);
}
